import { cn } from "@/lib/utils";
import { Spinner } from "@phosphor-icons/react";

function Loading({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        "flex flex-row items-center justify-center w-full h-full",
        "gap-4 text-4xl text-gray-500 rounded-r-3xl bg-background animate-pulse",
        className
      )}
    >
      <Spinner className="!w-10 !h-10 mr-2 animate-spin" />
      Loading...
    </div>
  );
}

export default Loading;
